export const environments = {
  LOCAL_SERVER: 'LocalServer',
  LOCAL: 'Local',
  STAGING: 'Staging',
  PREPROD: 'Preprod',
  SANDBOX: 'Sandbox',
  PRODUCTION: 'Production'
}
